import React, { useContext, useEffect, useState } from "react";
import { FiEdit } from "react-icons/fi";
import { UserContext } from "../../../UserContext";

const apiBaseURL = process.env.REACT_APP_BACKEND_API_URL;

const WorkspaceConfig = () => {
  const [configurations, setConfigurations] = useState([]);
  const [editableConfigurations, setEditableConfigurations] = useState([]);  // eslint-disable-line no-unused-vars
  const [editingConfig, setEditingConfig] = useState(null);
  const [editingValue, setEditingValue] = useState("");
  const { user } = useContext(UserContext);

  useEffect(() => {
      const fetchSessionConfig = async () => {
    try {
      const response = await fetch(
        `${apiBaseURL}/configurations/${user.user_id}?configuration_type=Workspace`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.ok) {
        const data = await response.json();
        setConfigurations(data);
        setEditableConfigurations(data.map((config) => ({ ...config })));
      } else {
        console.error("Failed to fetch session configurations.");
      }
    } catch (error) {
      console.error("Error fetching session configurations:", error);
    }
  };

    fetchSessionConfig();
  }, [user.user_id]);

  const openEditModal = (config) => {
    setEditingConfig(config);
    setEditingValue(config.configuration_value);
  };

  const closeModal = () => {
    setEditingConfig(null);
    setEditingValue("");
  };

  const saveConfig = async () => {
    if (!editingConfig) return;

    try {
      const response = await fetch(
        `${apiBaseURL}/configurations/${user.user_id}/${encodeURIComponent(
          editingConfig.configuration_name
        )}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            configuration_value: editingValue,
          }),
        }
      );

      if (response.ok) {
        const updated = configurations.map((cfg) =>
          cfg.configuration_name === editingConfig.configuration_name
            ? { ...cfg, configuration_value: editingValue }
            : cfg
        );
        setConfigurations(updated);
        closeModal();
      } else {
        console.error(`Failed to update ${editingConfig.configuration_name}`);
      }
    } catch (error) {
      console.error("Error updating configuration:", error);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 p-6 font-gotham">
      <div className="max-w-7xl mx-auto">
        <div className="grid gap-6 grid-cols-1 sm:grid-cols-2 lg:grid-cols-2">
          {configurations.map((config) => (
            <div
              key={config.id}
              className="bg-white rounded-lg shadow hover:shadow-lg flex flex-col"
            >
              <div className="p-4 flex-1 flex flex-col justify-between">
                <div>
                  <h2 className="text-lg font-semibold text-gray-800">
                    {config.configuration_name}
                  </h2>
                  <div className="mt-2 text-sm text-gray-600 whitespace-pre-line max-h-48 overflow-hidden">
                    {config.configuration_value
                      .split("\n")
                      .slice(0, 10)
                      .join("\n")}
                  </div>
                </div>
                <button
                  onClick={() => openEditModal(config)}
                  className="mt-4 flex items-center text-blue-600 hover:text-blue-800 font-medium"
                >
                  <FiEdit className="mr-2" />
                  Edit
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>

      {editingConfig && (
        <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50 z-50">
          <div className="bg-white w-1/2 h-2/3 p-3 rounded-lg shadow-lg">
            <h2 className="text-xl font-semibold text-gray-800 mb-4">
              Edit {editingConfig.configuration_name}
            </h2>
            <textarea
              className="w-full h-[85%] p-2 border border-gray-300 rounded text-gray-800 resize-none"
              value={editingValue}
              onChange={(e) => setEditingValue(e.target.value)}
            />
            <div className="flex justify-end mt-1 space-x-3">
              <button
                onClick={saveConfig}
                className="px-2 py-1 bg-teal-400 text-black font-semibold rounded hover:bg-teal-500"
              >
                Save
              </button>
              <button
                onClick={closeModal}
                className="px-2 py-1 bg-gray-300 text-gray-800 font-semibold rounded hover:bg-gray-400"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default WorkspaceConfig;
